import { Component, EventEmitter, HostListener, output, ViewChild, signal } from '@angular/core';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { UtilisateurService } from 'src/app/services/utilisateur.service';
import { Equipe } from '../../bo/equipe';
import { Operator } from '../../bo/operator';
import { Probleme } from '../../bo/probleme';
import { Projet } from '../../bo/projet';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { Rotation } from '../../bo/rotation';
import { Tir } from '../../bo/tir';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { TraductionService } from '../../services/traduction.service';
import { Equipment } from 'src/app/bo/equipment';
import { ShiftEnum, Shift, ShiftUtils } from 'src/app/bo/shifts/shift';
import { StaticUtils } from 'src/app/utils/staticUtils';

@Component({
  selector: 'app-donnees-suivi-operationnel-modale',
  templateUrl: './donnees-suivi-operationnel-modale.component.html',
  styleUrls: ['./donnees-suivi-operationnel-modale.component.scss'],
  standalone: false
})

export class DonneesSuiviOperationnelModaleComponent {
  addDataEmitter = output<Shift>();
  modifDataEmitter = output<Shift>();
  deletedIdEmitter = output<number>();
  modaleFermee = output<boolean>();
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  @ViewChild('modalConfirmAddOrUpdate') modalConfirmAddOrUpdate: ModalDirective;
  tabTirs: Tir[];
  tabEquipes: Equipe[];
  tabProblemes: Probleme[];
  rotation: Rotation;
  rotationSauv: Rotation;
  tirSelectionne: Tir;
  equipeSelectionnee: Equipe;
  problemesSelectionnes: Probleme[];
  propAffOperation: ProprieteAffichee[];
  estModif: boolean;
  estProjet: boolean;
  projet: Projet;
  dateDebProjet: Date;
  dateFinProjet: Date;
  dateShift: Date;
  siteId: number;
  modalOp: BsModalRef = null;
  ajoutOperationActif: boolean;
  dureeTotaleOps: number;
  equipmentsNonRenseigne = signal(false);
  dateNonRenseigne = signal(false);
  timeNonRenseigne = signal(false);
  equipeNonRenseigne = signal(false);
  suppression = signal(false);
  success = signal(false);
  modalOperationOpened: boolean;
  erreurApi = signal(false);
  tabTime: { label: string; value: ShiftEnum }[];
  timeSelectione: ShiftEnum;
  shiftSelectione: Shift;
  oldShiftSelectionne: Shift;
  tabEquipments: Equipment[] = undefined;
  equipmentsSelectione: Equipment[] = [];
  oldEquipmentsSelectione: Equipment[] = [];
  tabOperateurs: Operator[];
  operateurSelectionne: Operator;
  hourEnum: ShiftEnum;
  shiftDisable = signal(true);
  allSiteShiftsByDate: Shift[] = [];
  existingShift: Shift;
  existingShiftTirId = signal<number>(null);
  existingShiftDate = signal<string>('');
  existingShiftTime = signal<string>('');
  todayDate: Date = new Date();
  tabShifts: Shift[];

  constructor(public bsModalRef: BsModalRef, private readonly tradService: TraductionService, private readonly http: HttpService, public modalService: BsModalService,
    public fonctionsService: FonctionsService, private readonly utilService: UtilisateurService) {
    this.tabTime = [
      { label: this.tradService.instant(this.formatShiftLabel(ShiftEnum.NightToMorning)), value: ShiftEnum.NightToMorning },
      { label: this.tradService.instant(this.formatShiftLabel(ShiftEnum.MorningToAfternoon)), value: ShiftEnum.MorningToAfternoon },
      { label: this.tradService.instant(this.formatShiftLabel(ShiftEnum.AfternoonToEvening)), value: ShiftEnum.AfternoonToEvening }
    ];
  }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }
    if (!this.modalOp)
      this.showModalCancel();
  }

  getShiftForThisDate() {
    if (!this.dateShift) {
      return;
    }

    let record: Record<string, string | number | boolean> = {
      date: this.dateShift.toISOString(),
    };

    this.http.get<Shift[]>('Blasts/' + this.utilService.currentTir.siteId + '/shiftsByTirIdAndDate/' + this.utilService.currentTir.tirId, record).subscribe({
      next: (results) => {
        this.shiftDisable.set(false);
        this.dateNonRenseigne.set(false);
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  clearError() {
    this.validationFormulaire()
  }

  ngOnInit() {
    if (!this.estModif) {
      this.rotation = new Rotation();
      this.rotation.duree = 0;
      this.dateShift = null;
    } else {
    }
    this.dateDebProjet = new Date(this.projet.dateDebutEffective ? this.projet.dateDebutEffective : this.projet.dateDebutPrevisionnelle);
    this.dateFinProjet = new Date(this.projet.dateFinEffective ? this.projet.dateFinEffective : this.projet.dateFinPrevisionnelle);
    this.GetAllShift();
  }

  onSubmit() {
    if (!this.validationFormulaire()) {
      return;
    }

    const shiftId = (this.shiftSelectione && this.shiftSelectione.shiftId) ? this.shiftSelectione.shiftId : 0;
    const equipeId = (this.equipeSelectionnee && this.equipeSelectionnee.equipeId) ? this.equipeSelectionnee.equipeId : 0;
    const operateurId = (this.operateurSelectionne && this.operateurSelectionne.operatorId) ? this.operateurSelectionne.operatorId : 0;
    this.shiftSelectione = {
      shiftId: shiftId,
      date: new Date(this.dateShift),
      tirId: this.utilService.currentTir.tirId,
      siteId: this.utilService.currentTir.siteId,
      equipeId: equipeId,
      operatorId: operateurId,
      time: this.timeSelectione,
      equipementsIds: this.equipmentsSelectione.map(x => x.externalId).join(';'),
      isDeleted: false
    }

    this.existingShift = this.allSiteShiftsByDate.find(shift => this.compareShifts(shift, this.shiftSelectione));

    if (this.existingShift && !this.existingShift.isDeleted) {
      const dateFormat = StaticUtils.getDateTimeFormat(this.tradService.translate.currentLang);
      const shiftDate = new Date(this.existingShift.date);
      this.existingShiftTirId.set(this.existingShift.tirId);
      this.existingShiftDate.set(shiftDate.toLocaleDateString(this.tradService.translate.currentLang, dateFormat));
      this.existingShiftTime.set(this.formatShiftLabel(this.existingShift.time));
      this.modalConfirmAddOrUpdate.show();
    } else {
      this.addOrUpdateShift();
    }
  }

  private addOrUpdateShift() {
    try {
      let requete = this.estModif || this.tabShifts.length > 0? this.http.put<Shift, Shift>('Blasts/shifts', this.shiftSelectione) :
        this.http.post<Shift, Shift>('Blasts/shifts', this.shiftSelectione);

      requete.subscribe({
        next: (response) => {
          this.shiftSelectione.equipements = this.equipmentsSelectione;
          if (this.estModif) {
            this.modifDataEmitter.emit(this.shiftSelectione);
          } else {
            this.shiftSelectione.shiftId = response.shiftId;
            this.addDataEmitter.emit(this.shiftSelectione);
          }
          this.fonctionsService.launch_toast(true);
          this.bsModalRef.hide();
        },
        error: () => {
          this.fonctionsService.launch_toast(false);
        }
      });
    } catch (error) {
      console.error(error);
    }
  }

  private sendUpdateRequest(shift: Shift): void {
    const requete = this.http.put<Shift, Shift>('Blasts/shifts', shift);
    requete.subscribe({
      next: (response) => {
        this.modifDataEmitter.emit(this.shiftSelectione);
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      },
      error: (err) => {
        console.error("Error updating shift:", err);
        this.fonctionsService.launch_toast(false);
      }
    });
  }

  protected GetAllShift() {
    this.http.get<Shift[]>('Blasts/' + this.utilService.currentTir.siteId + '/shifts/').subscribe({
      next: (results) => {
        this.allSiteShiftsByDate = results;
      },
      error: (err) => {
        console.error("Error fetching shifts:", err);
      }
    })
  }

  private compareShifts(shift1: Shift, shift2: Shift): boolean {
    const isSameTime = shift1.time === shift2.time;

    const isSameDate = new Date(shift1.date).toDateString() === new Date(shift2.date).toDateString();

    const equipementIds1 = shift1.equipementsIds.split(';');
    const equipementIds2 = shift2.equipementsIds.split(';');

    const hasCommonEquipement = equipementIds1.some(id1 => equipementIds2.includes(id1));

    return isSameTime && isSameDate && hasCommonEquipement;
  }

  validationFormulaire() {
    this.equipmentsNonRenseigne.set(this.equipmentsSelectione == null || this.equipmentsSelectione.length < 1);
    this.timeNonRenseigne.set(this.timeSelectione == null);
    this.dateNonRenseigne.set(!this.dateShift);

    return !this.timeNonRenseigne() && !this.dateNonRenseigne() && !this.equipmentsNonRenseigne();
  }

  showModalCancel() {
    this.bsModalRef.hide();
  }

  showConfirmSuppr() {
    this.modalConfirmSuppr.show();
  }

  hideModalCancel() {
    this.modalConfirmCancel.hide();
  }

  hideConfirmSuppr() {
    this.modalConfirmSuppr.hide();
  }

  delete() {
    this.http.delete<number>('Blasts/' + this.utilService.currentSite().siteId + '/shifts/' + this.shiftSelectione.shiftId).subscribe({
      next: (response) => {
        this.deletedIdEmitter.emit(this.shiftSelectione.shiftId);
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    })
  }

  deleteShift(shiftId: number) {
    this.http.delete<number>('Blasts/' + this.utilService.currentSite().siteId + '/shifts/' + shiftId).subscribe({
      next: (response) => {
        this.deletedIdEmitter.emit(this.shiftSelectione.shiftId);
        this.fonctionsService.launch_toast(true);
        this.bsModalRef.hide();
      },
      error: () => {
        this.fonctionsService.launch_toast(false);
      }
    })

  }

  nettoyerDates() {
    this.dateShift = null;
  }

  formatShiftLabel(shift: ShiftEnum): string {
    return ShiftUtils.formatShiftLabel(shift);
  }

  shouldAddShift(): boolean {
    return !this.oldEquipmentsSelectione || this.oldEquipmentsSelectione.length === 0
  }

  onConfirmUpdate() {
    this.shiftSelectione.shiftId = this.existingShift.shiftId;
    if (this.tabShifts === undefined ||this.tabShifts.length === 0){
      this.addOrUpdateShift();
    }else{
      this.sendUpdateRequest(this.shiftSelectione);
    }
    this.modalConfirmAddOrUpdate.hide(); 
  }

  getDateFormat(): string {
    return StaticUtils.getDatePickerDateFormat(this.tradService.translate.currentLang);
  }
}
